import { render, staticRenderFns } from "./ModalAutoText.vue?vue&type=template&id=7475742d&"
import script from "./ModalAutoText.vue?vue&type=script&lang=js&"
export * from "./ModalAutoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports